module.exports = __webpack_public_path__ + "img/pdf.cb7648e7.svg";